import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/lib/css-base'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import sbolViewer from '~root/./src/views/Viewer.vue?shadow'
window.customElements.define('sbol-viewer', wrap(Vue, sbolViewer))